export const LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'USER_LOGIN_FAILURE';

export const LOGOUT = 'USER_LOGOUT';
export const AUTH = 'USER_AUTH';

export const REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'USER_REGISTER_FAILURE';